const Schools = {
    INTERFACE: 'INTERFACE',
    MOBILE: 'MOBILE',
    DESIGN: 'DESIGN'
}

export default Schools



// WEBPACK FOOTER //
// ./src/schedule/Schools.js